export namespace StatementOfAccountConstants {

    export enum StatementType {
        OUTSTANDING_DOCUMENTS = 'OUTSTANDING_DOCUMENTS',
        TRANSACTION_HISTORY = 'TRANSACTION_HISTORY',
        SUBLEDGER = 'SUBLEDGER'
    }
    export enum RunType {
        PRINT = 'PRINT',
        EMAIL = 'EMAIL',
    }
} 